export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6988.c374a0c9.jpg";